import React from "react";
import { Text, TextLink } from "@origin-digital/ods-core";
import styled from "styled-components";

const Container = styled.div`
  padding: 82px 0;
  display: grid;
  gap: 32px;

  * {
    text-align: center;
  }
`;

const FullHeightWrapper = styled.div`
  height: 100vh;
  ${({ theme }) => theme.breakpoints.up("lg")} {
    height: auto;
    min-height: 40vh;
  }
`;

type Props = {
  spellingSuggestion?: string;
};

export const SpellingSuggestion = ({ spellingSuggestion }: Props) =>
  spellingSuggestion && (
    <Text>
      Did you mean{" "}
      <Text inline tone="neutralDark" weight="medium">
        <TextLink
          data-id="spelling-suggestion"
          href={`?term=${encodeURIComponent(spellingSuggestion)}`}
        >
          {spellingSuggestion}
        </TextLink>
      </Text>
      ?
    </Text>
  );

export const NoResults = ({ spellingSuggestion }: Props) => {
  return (
    <FullHeightWrapper data-id="no-results">
      <Container>
        <Text tone="neutralDark" variant="subtitle-small" weight="medium">
          No results found
        </Text>
        <div>
          <SpellingSuggestion spellingSuggestion={spellingSuggestion} />
          <Text>
            {spellingSuggestion ? "Or try" : "Try"} using a different search
            query
          </Text>
        </div>
      </Container>
    </FullHeightWrapper>
  );
};
